export default __webpack_public_path__ + "static/draft-kings-e06011501dc28531bc93c8dd0a959cb2.svg";